module.exports = __webpack_public_path__ + "img/search.789b0692.svg";